import React from 'react';

import CraftItem from './JSON/CraftItem.json';
import Result from './Result';
import ItemLabel from './ItemLabel';

import { get, set } from './storage';
import extractRecipe from './utils/extractRecipe';
import subtract from './utils/subtract';
import isEmpty from './utils/isEmpty';

const getInitialState = () =>
  Object.keys(CraftItem).reduce((acc, id) => ({ ...acc, [id]: 0 }), {});

export default class Craft extends React.Component {
  state = {
    values: get('items') || getInitialState(),
  };
  getItemIDs = () => {
    const { page } = this.props;
    const count = page === 0 ? 5 : 6;
    const startIdx = page === 0 ? 0 : page * 6 - 1;
    return Object.keys(CraftItem).slice(startIdx, startIdx + count);
  };
  setValue = (id, value) => {
    const values = { ...this.state.values, [id]: value };
    this.setState({ values });
    set('items', values);
  };
  clear = () => {
    const values = getInitialState();
    this.setState({ values });
    set('items', values);
  };
  draw = () => {
    const items = this.getItemIDs();
    return (
      <div className="craft-items my-3">
        {items.map(id => (
          <div className="craft-item" key={id}>
            <ItemLabel id={id} />
            <input
              className="form-control bg-dark text-light"
              value={this.state.values[id] || ''}
              onFocus={e => e.target.select()}
              onChange={e =>
                this.setValue(id, parseInt(e.target.value, 10) || 0)
              }
            />
          </div>
        ))}
      </div>
    );
  };
  render() {
    const { values } = this.state;
    const { craftable, materials } = extractRecipe(values);
    const midCraftable = subtract(craftable, values);
    return (
      <div>
        {this.draw()}

        <div className="mx-auto" style={{ width: 640 }}>
          {isEmpty(values) || (
            <Result label="注文加工品" variant="primary" result={values} />
          )}
          {isEmpty(midCraftable) ? null : (
            <Result
              label="二次加工品"
              variant="success"
              result={midCraftable}
            />
          )}
          {isEmpty(materials) ? null : (
            <Result
              label="採取できる資源"
              variant="warning"
              result={materials}
            />
          )}
        </div>
        <small className="text-secondary">
          ※カーソルを赤いマークに移動したらガチャ種類が表示されます
        </small>
        <hr />

        <button className="btn btn-danger btn-sm" onClick={this.clear}>
          全クリア
        </button>
      </div>
    );
  }
}
